import React     from "react";
import { Image } from 'react-native';

export default function AnimatedLogo({ height=45, width=45}) {
  return (
    <Image
      source={require("~/assets/logo-animated.gif")}
      style={{ height, width }}
    />
  );
}
